import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect, useState } from 'react'
import { consultService } from '../services/consultService'
import { GetAllConsultsParams } from '../services/consultService/getAllConsults'

export const useGetAllConsults = (initialParams?: GetAllConsultsParams) => {
  const defaultParams: GetAllConsultsParams = {
    limit: 100,
    search: '',
    ...initialParams,
  }

  const [params, setParams] = useState<GetAllConsultsParams>(defaultParams)

  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['consults', params],
    queryFn: async () => consultService.getAllConsults(params),
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar as consultas. Tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
    refetchWithParams: (customParams: GetAllConsultsParams) =>
      consultService.getAllConsults({ limit: 100, ...customParams }),
  }
}
